// extracted by mini-css-extract-plugin
export var checkbox = "_8o-0";
export var circle = "_8o-3";
export var horizontalContainer = "_8o-7";
export var sm = "_8o-5";
export var switch0 = "_8o-2";
export var switchDisabled = "_8o-8";
export var switchEnabled = "_8o-1";
export var textSwitchContainer = "_8o-9";
export var textSwitchOption = "_8o-a";
export var textSwitchOptionSelected = "_8o-b";
export var verticalContainer = "_8o-6";
export var xs = "_8o-4";